import React, { useState } from 'react';

import { InfoOutlined } from '@mui/icons-material';
import { Chip } from '@mui/material';

import RoleActionsModal from '~/components/v2/common/Modal/RoleActionsModal';

import { OrderAccessRoleLabel } from '~/consts/orderAccess';

type Props = {
  accessRole: App.OrderAccessRole;
};

export function OrderAccessRoleChip({ accessRole }: Props) {
  const [modalOpen, setModalOpen] = useState(false);

  const handleChipClick = () => {
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  return (
    <>
      <Chip
        icon={<InfoOutlined />}
        label={OrderAccessRoleLabel[accessRole]}
        onClick={handleChipClick}
        size="small"
        color="secondary"
        variant="filled"
      />
      <RoleActionsModal open={modalOpen} onClose={handleCloseModal} role={accessRole} />
    </>
  );
}
